import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import { Box, Typography } from '@mui/material';
import { IStoreCard } from './IStoreCard';
import StorefrontIcon from '@mui/icons-material/Storefront';

const StoreCard = ({ description, logo, onClick, title }: IStoreCard) => {
    return (
        <Box onClick={() => onClick()} sx={{

            border: '1px solid var(--border-color)',
            backgroundColor: "var(--input-bg-color)", width: "100%", borderRadius: "8px", padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center"
        }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>

                {logo ? (
                    <Box sx={{ height: "fit-content", width: "fit-content", border: "1px solid var(--border-color)", borderRadius: "8px", padding: "5px", background: "#fff" }}>
                        <img
                            src={logo}
                            style={{
                                objectFit: 'contain',
                                width: "60px",
                                height: "60px",
                            }}
                        />
                    </Box>
                ) :
                    (
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <StorefrontIcon sx={{ color: "#D7DBEC", fontSize: "50px" }} />
                        </Box>
                    )
                }

                <Typography sx={{ display: "flex", flexDirection: "column", gap: "10px", color: "var(--primary-text-color)", fontSize: "0.875rem" }}>
                    <span style={{ fontWeight: "bold", fontSize: "0.875rem" }}>{title}</span>{" "}
                    <span style={{ fontSize: "0.7rem", color: "gray" }}>
                        {description}
                    </span>
                </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <ChevronLeftOutlinedIcon sx={{ fontSize: "1.5rem", color: "gray" }} />
            </Box>
        </Box>
    )
}

export default StoreCard